"use client";

import React from "react";
import { Flame, Clock, Shield } from "lucide-react";
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const pillars = [{
  icon: Flame,
  title: "Procesos Limpios",
  description: "Implementamos tecnologías de vanguardia para reducir emisiones y optimizar el consumo energético en cada etapa de producción."
}, {
  icon: Clock,
  title: "Ciclo de Vida",
  description: "Maximizamos la durabilidad del acero y fomentamos la economía circular mediante programas de reciclaje industrial de alto impacto."
}, {
  icon: Shield,
  title: "Compromiso Social",
  description: "Garantizamos la seguridad de nuestros colaboradores y el desarrollo sostenible de las comunidades donde operamos."
}];
export default function GalerADeIniciativas() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}